import React, {useEffect, useRef, useState} from 'react';
import {Card, CardContent} from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import {COLORS} from '@/utils/constants';
import strSlug from '@/utils/strSlug';

interface Props {
    baseline: any[];
}

const CATEGORIES = [
	{
		name: 'Family & friends',
		value: 'Item 1',
	},
	{
		name: 'Business Angels',
		value: 'Item 2',
	},
	{
		name: 'Crowdfunding',
		value: 'Item 3',
	},
	{
		name: 'Incubators and Accelerators',
		value: 'Item 4',
	},
	{
		name: 'NGO’s loans',
		value: 'Item 5',
	},
	{
		name: 'NGO’s grants',
		value: 'Item 6',
	},
	{
		name: 'Public subsidies (e.g. tax credits)',
		value: 'Item 7',
	},
	{
		name: 'Public grants',
		value: 'Item 8',
	},
	{
		name: 'Venture capital',
		value: 'Item 9',
	},
	{
		name: 'Microfinance',
		value: 'Item 10',
	},
	{
		name: 'Financial institutions (banks)',
		value: 'Item 11',
	},
	{
		name: 'Other',
		value: 'other',
	},
];

const ReasonOfFailure = ({baseline}: Props) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
		const data: {[index: string]:number} = {};

		CATEGORIES.forEach((category) => {
			data[strSlug(category.value)] = 0;
		})

		baseline.forEach((submission: any) => {
			Object.keys(submission).forEach((key) => {
				if (key.startsWith('question10_')) {
					const category = CATEGORIES.find((category) => category.value === submission[key]);

					if (category) {
						const searchKey = strSlug(category.value);
						data[searchKey] = (data[searchKey] || 0) + 1;
					}
				}
			})

		})

        const dashboardOptions: Highcharts.Options = {
            chart: {
                type: 'bar',
            },
            xAxis: {
				categories: CATEGORIES.map((category) => category.name),
			},
            legend: {
                verticalAlign: 'bottom',
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                    },
                    groupPadding: 0.1,
                },
            },
            title: {
                text: 'Kind of Funds requested before the program',
                align: 'left',
            },
            series: [
                {
                    type: 'column',
                    name: 'BASELINE',
                    data: Object.values(data),
                    color: COLORS.blue,
                }
            ],
        };

		setOptions(dashboardOptions);
    };

    useEffect(() => {
		calculateSubmissions();
    }, []);

    return (
		<Card className='chart-container'>
			<CardContent>
				{options && (
					<HighchartsReact
						highcharts={Highcharts}
						options={options}
						ref={chartComponentRef}
					/>
				)}
			</CardContent>
		</Card>
    );
};

export default ReasonOfFailure;
